import { ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO } from '../types'

export default function alterarRegistrosPorPaginaCentroCusto (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_CENTRO_CUSTO,
    payload: valor
  }
}
